
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import UIkit from "uikit";
import PrivacyPolicyForm from "../organisms/PrivacyPolicyForm.vue";
import SearchField from "../atoms/SearchField.vue";
import Store from "../../store";
import HelpIcon from "../atoms/HelpIcon.vue";
import { SystemApi, PrivacyPolicyResponse, LanguagesEnum } from "../../autogen";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    PrivacyPolicyForm,
    SearchField,
    HelpIcon
  }
})
export default class ExamManage extends Vue {
  private readonly storeInstance = Store.getInstance();
  @Ref("modal") modal!: HTMLElement;
  @Ref("form") form!: HTMLElement;
  formKey = 0;
  query = "";
  lang: keyof typeof LanguagesEnum = "ja";
  formData: PrivacyPolicyResponse = {};

  private async loadData(lang: keyof typeof LanguagesEnum) {
    const response = await new SystemApi().getPrivacyPolicy({
      language: lang
    });
    this.formData = response.data;
  }

  onSubmitted() {
    UIkit.modal(this.modal).hide();
  }
  async openModal(lang: keyof typeof LanguagesEnum) {
    this.formKey = Date.now();
    this.lang = lang;
    await this.loadData(lang);
    UIkit.modal(this.modal).show();
  }
}
